// Generated from SVG to Code Figma Plugin

export const ChannelWechat3 = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10.1406 14.5813C10.1406 17.4088 12.9287 19.7025 16.3494 19.7025C17.1799 19.7025 17.9906 19.5641 18.7025 19.3268C18.9002 19.4257 20.3239 20.6517 20.6403 20.4342C20.8578 20.2562 20.1262 18.9314 20.0668 18.6941C21.5696 17.7648 22.5583 16.262 22.5583 14.5813C22.5583 11.7537 19.7702 9.45996 16.3494 9.45996C12.9287 9.45996 10.1406 11.7537 10.1406 14.5813Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M18.3449 12.1694C17.8952 12.1694 17.5355 12.5292 17.5355 12.9788C17.5355 13.4285 17.8952 13.7882 18.3449 13.7882C18.7945 13.7882 19.1542 13.4285 19.1542 12.9788C19.1542 12.5292 18.7945 12.1694 18.3449 12.1694Z"
      fill="currentColor"
    />
    <path
      d="M14.3699 12.1694C13.9203 12.1694 13.5605 12.5292 13.5605 12.9788C13.5605 13.4285 13.9203 13.7882 14.3699 13.7882C14.8196 13.7882 15.1793 13.4285 15.1793 12.9788C15.1793 12.5292 14.8196 12.1694 14.3699 12.1694Z"
      fill="currentColor"
    />
    <path
      d="M17.3444 9.4583C16.9436 6.17589 13.5658 3.61865 9.46276 3.61865C5.09256 3.61865 1.54297 6.53848 1.54297 10.1453C1.54297 12.2827 2.8025 14.1911 4.72997 15.3743C4.65363 15.6605 3.73761 17.359 4.00478 17.588C4.40554 17.8552 6.21851 16.2903 6.4666 16.1758C7.38262 16.4812 8.39406 16.6529 9.46276 16.6529C9.84443 16.6529 10.2261 16.6338 10.6078 16.5766"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M12.0709 6.89941C12.6645 6.89941 13.1501 7.38504 13.1501 7.97858C13.1681 8.57212 12.6825 9.05775 12.0709 9.05775C11.4774 9.05775 10.9918 8.57212 10.9918 7.97858C10.9918 7.38504 11.4774 6.89941 12.0709 6.89941ZM6.83698 9.05775C6.24344 9.05775 5.75781 8.57212 5.75781 7.97858C5.75781 7.38504 6.24344 6.89941 6.83698 6.89941C7.43052 6.89941 7.91615 7.38504 7.91615 7.97858C7.91615 8.57212 7.43052 9.05775 6.83698 9.05775Z"
      fill="currentColor"
    />
  </svg>
);
